import React from 'react'
import Component from '../../components/Component'
import { Container, Typography, Grid, Paper } from '@mui/material';
import { Link, Navigate } from 'react-router-dom';
import {useSelector} from 'react-redux';


function Dashboard() {
  const userId = useSelector((state) => state.roleReducer.userId);
  const isCreatedByAdmin = useSelector((state) => state.roleReducer.isCreatedByAdmin);
  console.log('userId', userId)
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.post(
  //         `${BASE_URL}/admin/authenticate`,
  //         {}, // Request body (empty in this case)
  //         {
  //           withCredentials: true, // Ensure cookies are included in the request
  //           headers: {
  //             'Content-Type': 'application/json',
  //           }
  //         }
  //       );
  //       if(response?.data?.statusCode == 10000){
  //         console.log('User is authenticated')
  //         setAuthenticated(true);
  //         return;
  //       }
  //       else{
  //       window.alert('User is not authenticated');
  //       window.location = '/login';

  //       }
        
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       window.alert('User is not authenticated');
  //       window.location = '/login';
  //     }
  //   };
  //   fetchData();
  // }, []); 
  if (!userId) {
    return null;
  }
  if (isCreatedByAdmin) {
    return <Navigate to="/feeds/create" replace />;
  }
  else{
  return (
    <div>
      <Component>
        <div class="page-body">
          <div class="container-fluid">
            <div class="page-header">
              <div class="row">

                <div class="col-sm-6">
                  <h3>Dashboard</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="container-fluid">
            <div class="row">

              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body" style={{ height: '75vh' }}>
                    <div className='row'>

                    </div>
                    <div class="row">
                      <Container maxWidth="lg" sx={{ marginTop: '30px' }}>
                        <Grid container spacing={3}>
                          <Grid id = "1" item xs={4}>
                            <Link to="/player-photo" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#2C3E50', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/player-image.png" alt="" />
                                <Typography variant="h5" gutterBottom>Player Images</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "2" item xs={4}>
                            <Link to="/match-panel" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#2980B9', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/player.png" alt="" />
                                <Typography variant="h5" gutterBottom>Match Panel</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "3" item xs={4}>
                            <Link to="/content-dashboard" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Content Dashboard</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "4" item xs={4}>
                            <Link to="/new-user-dashboard" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/newUsers.svg" alt="" />
                                <Typography variant="h5" gutterBottom>New User Dashboard</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "5" item xs={4}>
                            <Link to="/add-roles" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Add Roles</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/competitions" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Competitions</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/Icons" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Icons</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/notifications" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Notifications</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/new-installs" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>New Installs</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/copy-url" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Copy Url Logs</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/inapp-notifications" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>In App Notifications</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "6" item xs={4}>
                            <Link to="/top-posts" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#27AE60', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Top Posts</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "7" item xs={4}>
                            <Link to="/sponsored-ads" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#8E44AD', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Sponsored Ads</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          {/* <Grid id = "8" item xs={4}>
                            <Link to="/topics" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#E1D665', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Topics</Typography>
                              </Paper>
                            </Link>
                          </Grid> */}
                          <Grid id = "9" item xs={4}>
                            <Link to="/competition-images" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#E67E22', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/player-image.png" alt="" />
                                <Typography variant="h5" gutterBottom>Competition Images</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "10" item xs={4}>
                            <Link to="/stickers" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#9B59B6', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/player-image.png" alt="" />
                                <Typography variant="h5" gutterBottom>Stickers</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "11" item xs={4}>
                            <Link to="/feed-topics" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#16A085', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Feed Topics</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "12" item xs={4}>
                            <Link to="/memes" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#F39C12', color: '#FFFFFF' }}>
                                <img className='player-icon' src="https://reels-bucket-input.s3.ap-south-1.amazonaws.com/images.jpeg" alt="" />
                                <Typography variant="h5" gutterBottom>Memes</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "13" item xs={4}>
                            <Link to="/banners" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#1ABC9C', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Banner</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "14" item xs={4}>
                            <Link to="/admin/quick-links" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#34495E', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Quick Links</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "15" item xs={4}>
                            <Link to="/admin/arcade" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#C0392B', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/player.png" alt="" />
                                <Typography variant="h5" gutterBottom>Game Dashboard</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "16" item xs={4}>
                            <Link to="/admin/referrals-dashboard" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#6C5CE7', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Referral Dashboard</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "72" item xs={4}>
                            <Link to="/admin/referrals/codes" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#5B4DB8', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Referral Codes</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Edit codes &amp; join FE bonus
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "88" item xs={4}>
                            <Link to="/admin/users/delete" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#9A3412', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Delete Fan</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Dev only. Same email can sign up again
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "91" item xs={4}>
                            <Link to="/admin/payments" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0F766E', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Payments</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Razorpay orders, dummy and live
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "18" item xs={4}>
                            <Link to="/admin/store" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#1F618D', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Store Dashboard</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Wallet, categories, gift cards &amp; merch
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "20" item xs={4}>
                            <Link to="/admin/fan-energy" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#E67E22', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan Energy Dashboard</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  FE balances &amp; user distribution
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "74" item xs={4}>
                            <Link to="/admin/fan-ledger" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#CA6F1E', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan Ledger</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Per-user Fan Energy audit trail
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "85" item xs={4}>
                            <Link to="/admin/fan-energy/leaderboard/season" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#D35400', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>FE Leaderboard</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Daily and season Fan Energy rankings
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "19" item xs={4}>
                            <Link to="/admin/fan-videos" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#8B5CF6', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan Video Dashboard</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>IPL stories &amp; global videos</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "20" item xs={4}>
                            <Link to="/admin/discover-sections" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0F766E', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Discover Sections</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>Cards, images &amp; IPL overrides</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid item xs={4}>
                            <Link to="/admin/curated-articles" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#7C3AED', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Curated Articles</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Merge sources → Pulse news (+ hot take)
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "17" item xs={4}>
                            <Link to="/admin/match-hashtag-topics" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0E7490', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Match Hashtag Topics</Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "21" item xs={4}>
                            <Link to="/admin/competition-rail" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#B45309', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Competition Rail</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Home V2 top 10 competitions
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "22" item xs={4}>
                            <Link to="/admin/fan-lounge" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#047857', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan Lounge</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Daily Cricket Talk squad &amp; sort order
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "90" item xs={4}>
                            <Link to="/admin/fan-scan" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#1D4ED8', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan Scan</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Quiz results and the live questions
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "68" item xs={4}>
                            <Link to="/streak-audit" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#DC2626', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Streak Audit</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Debug app streak breaks by user
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "70" item xs={4}>
                            <Link to="/admin/missions" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#7C3AED', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Missions</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Configure career missions &amp; monitor participants
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "88" item xs={4}>
                            <Link to="/admin/daily-missions?from=today" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#6D28D9', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Daily Missions</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  One mission for each calendar date
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "83" item xs={4}>
                            <Link to="/admin/pulse" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0EA5E9', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Pulse</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Match generation toggles &amp; Pulse cards
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "71" item xs={4}>
                            <Link to="/admin/reports" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#BE123C', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Report Dashboard</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Disable users &amp; soft-delete reported posts
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "80" item xs={4}>
                            <Link to="/admin/app-landing" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0F766E', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>App Landing</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Weighted cold-start tab distribution
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "90" item xs={4}>
                            <Link to="/admin/dummy-live" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#0F4C5C', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Dummy live</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Dev / QA. T20, ODI, and Test that stay live
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "89" item xs={4}>
                            <Link to="/admin/promo" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#B45309', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Promo surfaces</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  Corner ribbon, corner video, and tab bar
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>
                          <Grid id = "167" item xs={4}>
                            <Link to="/admin/fan-agents" style={{ textDecoration: 'none' }}>
                              <Paper elevation={3} sx={{ padding: '30px', textAlign: 'center', backgroundColor: '#9F1239', color: '#FFFFFF' }}>
                                <img className='player-icon' src="images/dashboard.png" alt="" />
                                <Typography variant="h5" gutterBottom>Fan agents</Typography>
                                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                                  @LoyalStump, @WhistlePodu, @CricJudge
                                </Typography>
                              </Paper>
                            </Link>
                          </Grid>

                        </Grid>
                        
                      </Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Component>
    </div>
  )
}
}

export default Dashboard
